module.exports = __webpack_public_path__ + "img/finish-oak.b5442012.jpg";